import React from "react";

import LinkIcon from "../../../images/icons/svg/external-link-icon.svg";
import ArrowUpIcon from "../../../images/icons/svg/sorting-arrow-up.svg";
import ArrowDownIcon from "../../../images/icons/svg/sorting-arrow-down.svg";

import styles from "./Table.module.scss";

const WIDE_COLUMNS = ["title", "library"];

export default (props) => {
  const { columns, rows, sort, onSort, openDraft } = props;

  return (
    <table className={styles.tableContainer}>
      <colgroup>
        {columns.map((column) => (
          <col
            key={column.key}
            span="1"
            className={
              WIDE_COLUMNS.includes(column.key) ? styles.colLarge : styles.col
            }
          />
        ))}
        <col span="1" className={styles.col} />
      </colgroup>
      <thead className={styles.header}>
        <tr>
          {columns.map((column) => {
            const sorted = sort.column === column.key;
            return (
              <th
                className={styles.columnName}
                key={column.key}
                onClick={() => onSort(column.key)}
              >
                <div className={styles.container}>
                  <div
                    className={`${styles.text} ${
                      sorted ? styles.textBold : ""
                    }`}
                  >
                    {column.label}
                  </div>
                  <div className={styles.icon}>
                    <img
                      className={
                        sorted && sort.direction === "desc" ? styles.show : ""
                      }
                      src={ArrowDownIcon}
                    />
                    <img
                      className={`${!sorted ? styles.arrowUpShow : ""} ${
                        sorted && sort.direction === "asc" ? styles.show : ""
                      }`}
                      src={ArrowUpIcon}
                    />
                  </div>
                </div>
              </th>
            );
          })}
          <th />
        </tr>
      </thead>
      <tbody className={styles.body}>
        {rows.map((row) => (
          <tr key={row.id} onClick={() => openDraft(row.id)}>
            {columns.map((column) => (
              <td key={column.key}>{row[column.key] || "-"}</td>
            ))}
            <td className={styles.link}>
              <div className={styles.container}>
                <div className={styles.text}> View</div>
                <img src={LinkIcon} />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
